<template>
    <div>
        <h1 class="display-1 font-weight-regular mb-4">{{ $t('versions-history') }}</h1>

        <v-container grid-list-md text-xs-center>
            <v-layout align-start justify-center row fill-height>
                <v-flex xs12 style="max-width: 600px">
                    <v-timeline dense dark>
                        <v-timeline-item v-for="(version, i) in versions" :key="i" small
                                         :color="(version.tag === versionApp) ? 'green' : 'blue'" label>
                            <v-card>
                                <v-card-title class="title" color="blue">
                                    <v-chip class="white--text ml-0" :color="(version.tag === versionApp) ? 'green' : 'blue'" label>
                                        <v-icon left>label</v-icon>{{ version.tag }}
                                        <span v-if="version.tag === versionApp" class="font-italic">&nbsp;({{ $t('current') }})</span>
                                    </v-chip>
                                    <v-spacer></v-spacer>
                                    <span class="body-1 grey--text ml-3 text-xs-right">{{ getDate(version.date) }}</span>
                                </v-card-title>
                                <v-card-text class="text--primary text-xs-left">
                                    <h2 class="title blue--text">{{ $t(version.title) }}</h2>
                                    <p class="mt-2" v-html="$t(version.description)"></p>
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/stores';
import versionsFile from '@/versions';
import moment from 'moment';

export default {
    store,
    computed: {
        ...mapGetters({
            versionApp: 'version',
        }),
        versions: function()
        {
            return versionsFile;
        },
    },
    methods: {
        getDate: function(date)
        {
            return moment(date).format('L');
        },
    },
};
</script>

<style scoped lang="scss">
</style>
